import React, { useMemo } from "react";
import { View } from "react-native";
import { useI18n } from "../../hooks/i18n-hooks";
import { useQuery } from "@apollo/client";
import { FIND_WORKER_INVOICES } from "../../graphql/invoices";
import SimplePageContent from "../../components/SimplePageContent";
import LoadingBoundary from "../../ui_atoms/LoadingBoundary";
import { StackScreenProps } from "@react-navigation/stack";
import EmptyListInfo from "../../ui_atoms/EmptyListInfo";
import VStack from "../../ui_atoms/VStack";
import { ClientWorkersTabParamList } from "../../navigations/client/WorkersNavigation";
import InvoiceItem from "../../components/InvoiceItem";

type Props = StackScreenProps<ClientWorkersTabParamList, "WorkerInvoices">;

const WorkerInvoices: React.FC<Props> = ({ route }) => {
    const i18n = useI18n();
    const { loading, error, data, refetch } = useQuery(FIND_WORKER_INVOICES, {
        fetchPolicy: "cache-and-network",
        variables: { workerProfileId: route?.params?.workerId || "" },
        skip: !route?.params?.workerId,
    });

    const allInvoices = useMemo(
        () => data?.findWorkerInvoices.elements || [],
        [data?.findWorkerInvoices.elements],
    );

    return (
        <View style={{ flex: 1 }}>
            <SimplePageContent refresh={refetch}>
                <LoadingBoundary
                    error={error}
                    loading={loading && !data}
                    clearError={() => {
                        void refetch();
                    }}
                >
                    {allInvoices.length == 0 ? (
                        <VStack h={1} v={1}>
                            <EmptyListInfo
                                text={i18n.t("screens.client_profile.tabs.invoices.no_invoices")}
                            />
                        </VStack>
                    ) : (
                        allInvoices.map((invoice) => (
                            <InvoiceItem key={invoice.id} invoice={invoice} />
                        ))
                    )}
                </LoadingBoundary>
            </SimplePageContent>
        </View>
    );
};

export default WorkerInvoices;
